<script>
import store from '@/store';
import router from '@/router';

import InfosApi from '@/api/infos';
import { mapActions } from 'vuex';

export default {
  name: 'Admin',
  data: () => ({
    versions: {
      front: 'inconnue',
      back: 'inconnue'
    },
    showMenu: false,
    menuItems: [
      { libelle: 'Rechercher un adhérent', route: 'admin.connect_as.selection_tiers', icon: 'mdi-account', badge: false, bottomMenu: true },
      { libelle: 'Paramètres', route: 'admin.parametres', icon: 'mdi-cog', badge: false, role: 'COM_ALI_ADMIN_METIER', bottomMenu: true },
      { libelle: 'Bannière de messages', route: 'admin.messages', icon: 'mdi-message-text-outline', badge: false, role: 'COM_ALI_ADMIN_METIER', bottomMenu: true }
    ]
  }),
  beforeRouteEnter (to, from, next) {
    store.dispatch('user/loadUser')
      .then((user) => {
        next();
      })
      .catch(error => {
        if (error && error.response && error.response.status === 403) {
          router.push({ name: 'error-logout', query: { cause: 'ACCES_NON_AUTHORISE' } });
        } else {
          next(error);
        }
      });
  },
  computed: {
    versionsTooltip () {
      return this.versions.front + ' - ' + this.versions.back;
    }
  },
  created () {
    this.versions.front = process.env.VUE_APP_VERSION;
    InfosApi.getVersion().then(
      version => { this.versions.back = version; },
      () => { this.versions.back = 'error'; }
    );
  },
  methods: {
    ...mapActions({ sessionLogout: 'session/logout' }),
    logout () {
      this.sessionLogout().finally(() => {
        this.$store.dispatch('reset');
        this.$router.push({ name: 'login' });
      });
    }
  }
};
</script>

<template>
  <div class="screen-size page-container">
    <Menu
      :show.sync="showMenu"
      hide-user-infos
      :items="menuItems"
    />
    <div
      v-if="!isMobile"
      class="left-spacer"
    />
    <div>
      <v-app-bar
        fixed
        app
      >
        <div class="menu-btn-container primary">
          <v-icon
            color="white"
            large
            @click="showMenu = true"
          >
            mdi-menu
          </v-icon>
        </div>
        <img
          v-if="isMobile"
          src="../../assets/images/logo_cdea_mobile.png"
          alt="Agrial"
          style="height:60%;width:auto;"
          :title="versionsTooltip"
        >
        <img
          v-else
          src="../../assets/images/logo_cdea.png"
          alt="Agrial"
          style="height:60%;width:auto;"
          :title="versionsTooltip"
        >
        <!--<span>{{ currentRoute }}</span>-->
        <!-- TODO : remove -->
        <div class="flex-fill" />
        <v-btn
          icon
          color="secondary"
          @click="logout()"
        >
          <v-icon>mdi-power</v-icon>
        </v-btn>
        <div style="width:15px;" />
      </v-app-bar>

      <v-main class="app-content">
        <div class="page-content">
          <router-view />
        </div>
      </v-main>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.page-container {
  display: flex;
  flex-direction: row;
  & > * {
    flex-grow: 1;
    max-width: 100%;
  }
}
.left-spacer {
  min-width: 70px;
  width: 70px;
  flex-grow: 0;
}
.v-toolbar ::v-deep .v-toolbar__content {
  padding: 0 !important;
}

.menu-btn-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 56px;
  margin-right: 20px;
}

.bandeau {
  margin: 1em 2vw 0 2vw;
}

.app-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-image: url("../../assets/images/bg-content.png");
  background-position: bottom right;
  background-repeat: no-repeat;
  background-size: auto 60%;
}

.footer {
  font-size: 0.9em;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  height: 120px;
  width: 100%;
  & > * {
    margin: 1.5em 3vw;
  }
  * {
    white-space: nowrap;
    max-height: 100%;
  }
  img {
    max-height: 50px;
    max-width: 23vw;
  }
}

@media #{map-get($display-breakpoints, 'xs-only')} {
  .footer {
    display: block;
    position: relative;
    text-align: right;
    margin-bottom: 50px;

    .footer-logo {
      position: absolute;
      top: 0;
      left: 0;
    }
    & > * {
      margin: 10px 2em;
    }
    * {
      text-align: right;
    }
  }

  .bandeau {
    margin: 0;

    .bandeau_text {
      padding: 10px;
    }
  }
}

.page-content {
  margin: 2vw;
  padding: 1vw;
  background-color: #F4F8F9;
}

@import '~vuetify/src/styles/settings/_variables';
@media #{map-get($display-breakpoints, 'xs-only')}{
  .page-content {
    margin: 0;
    padding: 3vw;
  }
}

</style>
